import { Grid, Header, Segment } from '@mairistem/composants';
import { Sens } from '@mairistem/comptabilite';
import { Icon } from '@mairistem/finances-utils';
import React from 'react';
import { toast } from 'react-toastify';
import DECISION from '../../constants/common/decision';
import STORAGE_KEY from '../../constants/common/storage';
import type { DashboardData } from '../../interfaces/dashboard/dashboardData';
import { getTableauBord } from '../../services/projet';
import ActivitePanel from './panels/ActivitePanel';
import AutorisationPanel from './panels/AutorisationPanel';
import CreditPanel from './panels/CreditPanel';
import EvolutionMensuellePanel from './panels/EvolutionMensuellePanel';

const defaultData: DashboardData = {
	activite: [],
	ae: {
		montant: 0,
		total: 0,
	},
	ap: {
		montant: 0,
		total: 0,
	},
	mois: [],
	pourcentage: 0,
};

const Dashboard = () => {
	const [data, setData] = React.useState<DashboardData>(defaultData);

	React.useEffect(() => {
		const fetchData = async () => {
			try {
				const res = await getTableauBord(
					new URLSearchParams({
						identifiantEntiteCompta: sessionStorage.getItem(
							STORAGE_KEY.ID_ENTITE_CPTA,
						),
						sens: Sens.DEPENSE,
					}),
				);

				setData(res);
			} catch {
				toast.error('Erreur lors du chargement du tableau de bord');
			}
		};

		fetchData();
	}, []);

	return (
		<Segment basic>
			<Segment basic>
				<Header>
					<Icon color="var(--accent)" iconSet="Lucide" name="House" />
					<Header.Content>
						Tableau de bord
						<Header.Subheader content="Vue d'ensemble de vos autorisations de programme et d'engagement" />
					</Header.Content>
				</Header>
				<Grid>
					<Grid.Row columns="equal">
						<Grid.Column>
							<AutorisationPanel decision={DECISION.AP} {...data.ap} />
						</Grid.Column>
						<Grid.Column>
							<AutorisationPanel decision={DECISION.AE} {...data.ae} />
						</Grid.Column>
						<Grid.Column>
							<CreditPanel progress={data.pourcentage} />
						</Grid.Column>
					</Grid.Row>
					<Grid.Row columns={2}>
						<Grid.Column>
							<EvolutionMensuellePanel data={data.mois} />
						</Grid.Column>
						<Grid.Column>
							<ActivitePanel data={data.activite} />
						</Grid.Column>
					</Grid.Row>
				</Grid>
			</Segment>
		</Segment>
	);
};

export default Dashboard;
